import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import MDButton from "components/MDButton";
import Modal from "modules/Modal/Modal";
import formatCentsToUSD from "utils/money/formatCentsToUSD";
import { SyncableJob } from "./quickbooksSyncUtils";
import { quickbooksCancelButtonSx } from "./quickbooksSyncStyles";

type Props = {
  addJobsToBatch: () => void;
  closeJobPicker: () => void;
  jobPickerOpen: boolean;
  jobPickerSearch: string;
  jobsLoading: boolean;
  pickerJobs: SyncableJob[];
  pickerSelectedJobIds: string[];
  setJobPickerSearch: (value: string) => void;
  togglePickerJob: (jobId: string) => void;
};

export default function QuickbooksJobPickerModal({
  addJobsToBatch,
  closeJobPicker,
  jobPickerOpen,
  jobPickerSearch,
  jobsLoading,
  pickerJobs,
  pickerSelectedJobIds,
  setJobPickerSearch,
  togglePickerJob,
}: Props) {
  return (
    <Modal
      open={jobPickerOpen}
      onClose={closeJobPicker}
      styles={{ width: "min(720px, 92vw)", height: "auto", maxHeight: "80vh", p: 3 }}
    >
      <Typography variant="h5" mb={2}>
        Add Job to Sync
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Select additional jobs to sync on the same invoice for the same customer.
      </Typography>
      <TextField
        fullWidth
        size="small"
        label="Search same-customer jobs"
        value={jobPickerSearch}
        onChange={(e) => setJobPickerSearch(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Stack spacing={1} sx={{ maxHeight: "48vh", overflow: "auto", pr: 1 }}>
        {pickerJobs.map((candidate) => (
          <Paper
            key={candidate.id}
            variant="outlined"
            sx={{ px: 1.5, py: 1, borderColor: "divider" }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={pickerSelectedJobIds.includes(candidate.id)}
                  onChange={() => togglePickerJob(candidate.id)}
                />
              }
              label={`${candidate.externalId} - ${candidate.name} (${formatCentsToUSD(
                candidate.totalCents
              )})`}
            />
          </Paper>
        ))}

        {!jobsLoading && pickerJobs.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No additional same-customer jobs are available.
          </Typography>
        )}
      </Stack>

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 3 }}>
        <MDButton color="light" onClick={closeJobPicker} sx={quickbooksCancelButtonSx}>
          Cancel
        </MDButton>
        <MDButton
          color="success"
          onClick={addJobsToBatch}
          sx={{
            color: "#fff",
          }}
        >
          Add Selected Jobs
        </MDButton>
      </Box>
    </Modal>
  );
}
